import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClearAll = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 9.15147L12.5757 6.57574L13.4243 7.42426L10.8485 10L13.4243 12.5757L12.5757 13.4243L10 10.8485L7.42426 13.4243L6.57574 12.5757L9.15147 10L6.57574 7.42426L7.42426 6.57574L10 9.15147Z",
		fill: "white"
	})
});
export default SvgClearAll;
